import React from 'react';
import { Button, TopActionBar } from '../components';
import { ModuleBridge } from '../components';

export const BinaryAssets = () => {
    return (
        <>
            <TopActionBar>
                <div>
                    <Button type="primary" className="button button--primary" onClick={() => window.newBinaryAsset()}>
                        Add New Migration Extension
                    </Button>
                </div>
            </TopActionBar>
            <div id="binary_assets_container"></div>
            <ModuleBridge moduleId="binary_assets_module" />
        </>
    );
};
